module.exports = __webpack_public_path__ + "static/img/more-text-2.dd91f6cd.png";